export class Social {
    profilId = '';
    active = true;
    link = '';
    findme = false;
    rank = 0;
    constructor(public name: string) { }
}
